var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"componente",style:({width: _vm.width, height:_vm.heigth, position: _vm.position, top:_vm.top, left:_vm.left })},[_c('v-select',{attrs:{"items":_vm.programas,"item-text":"name","item-value":"value","disabled":""},model:{value:(_vm.nuevo_valor),callback:function ($$v) {_vm.nuevo_valor=$$v},expression:"nuevo_valor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }